export const getCurrentVehicleIds = vehicle => {
  const savedVehicleId = parseInt(vehicle?.vehicleId || 0, 10);
  const browserVehicleId = parseInt(vehicle?.browser?.vehicleId || 0, 10);
  const hasSavedVehicleId = savedVehicleId > 0;
  const hasBrowserVehicleId = browserVehicleId > 0;
  const doesBrowserVehicleIdMatchSavedVehicleId =
    hasSavedVehicleId &&
    hasBrowserVehicleId &&
    browserVehicleId === savedVehicleId;
  const isVehicleAvailable = vehicle?.lock?.isAvailable;
  const switchingVehicle = vehicle?.switchingVehicle;

  return {
    savedVehicleId,
    browserVehicleId,
    hasSavedVehicleId,
    hasBrowserVehicleId,
    doesBrowserVehicleIdMatchSavedVehicleId,
    isVehicleAvailable,
    switchingVehicle
  };
};

export const getVehicleImageUrl = stockNumber =>
  `${process.env.VEHICLE_IMAGE_CDN_URL}/${stockNumber}/post-large/${stockNumber}-edc-02-search.jpg`;

export const getCloseUpVehicleImageUrl = stockNumber =>
  `${process.env.VEHICLE_IMAGE_CDN_URL}/${stockNumber}/post-large/normalized/zoomcrop/${stockNumber}-edc-02.jpg`;

export const getVehicleImages = vehicle => {
  return {
    vehicleImage: getVehicleImageUrl(vehicle.stockNumber)
  }
};
